export const GetTurnstileToken = (
  locVar: string,
  containerId = 'cft-container'
) => {
  const siteKey = '0x4AAAAAAAZb1HWNBc4ij50k'

  return new Promise<string | null>((resolve) => {
    const getToken = (token: string) => {
      localStorage.setItem(locVar, token)
      resolve(token)
    }

    if (typeof window === 'undefined') {
      resolve(null)
      return
    }

    const turnstileWindow = window as Window & {
      __turnstileWidgetIds?: Record<string, string | number>
      turnstile?: {
        render: (
          container: string,
          options: {
            sitekey: string
            callback: (token: string) => void
          }
        ) => string | number
        remove?: (widgetId: string | number) => void
      }
    }
    const turnstile = turnstileWindow.turnstile
    const container = document.getElementById(containerId)

    if (!turnstile || !container) {
      resolve(null)
      return
    }

    const existingWidgetId = turnstileWindow.__turnstileWidgetIds?.[containerId]

    if (existingWidgetId !== undefined && turnstile.remove) {
      turnstile.remove(existingWidgetId)
      delete turnstileWindow.__turnstileWidgetIds?.[containerId]
    }

    localStorage.removeItem(locVar)

    const widgetId = turnstile.render(`#${containerId}`, {
      sitekey: siteKey,
      callback: getToken,
    })

    turnstileWindow.__turnstileWidgetIds = {
      ...(turnstileWindow.__turnstileWidgetIds || {}),
      [containerId]: widgetId,
    }
  })
}
